import { render, staticRenderFns } from "./FormOhisuoritus.vue?vue&type=template&id=40a3419a&scoped=true&"
import script from "./FormOhisuoritus.vue?vue&type=script&lang=js&"
export * from "./FormOhisuoritus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a3419a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VForm,VMenu,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a3419a')) {
      api.createRecord('40a3419a', component.options)
    } else {
      api.reload('40a3419a', component.options)
    }
    module.hot.accept("./FormOhisuoritus.vue?vue&type=template&id=40a3419a&scoped=true&", function () {
      api.rerender('40a3419a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormOhisuoritus.vue"
export default component.exports